import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ADPResourceService } from 'digital-core';

@Injectable({
  providedIn: 'root'
})
export class AppInsightsService {
  private urlsToFilter = [];
  private exceptionWithPropertiesToFilter = [];
  private appInsights: ApplicationInsights;

  constructor(private resourceService: ADPResourceService) { }

  logPageView(name?: string, url?: string) { // option to call manually
    this.appInsights.trackPageView({
      name,
      uri: url
    });
  }

  logEvent(name: string, properties?: { [key: string]: any }) {
    this.appInsights.trackEvent({ name}, properties);
  }

  logMetric(name: string, average: number, properties?: { [key: string]: any }) {
    this.appInsights.trackMetric({ name, average }, properties);
  }

  logException(exception: any, severityLevel?: number) {
    if (exception.ErrorId) {
      this.loadCustomTelemetryProperties({
        'ApiRequestId': exception.ErrorId
      });
    }
    this.appInsights.trackException({ exception, severityLevel });
  }

  logTrace(message: string, properties?: { [key: string]: any }) {
    this.appInsights.trackTrace({ message }, properties);
  }

  loadAppInsightConfigs(insKey: string) {
    try {
      this.appInsights = new ApplicationInsights({
        config: {
          connectionString: "InstrumentationKey=" + insKey,
          instrumentationKey: insKey,
          enableAutoRouteTracking: true
        }
      });
      this.appInsights.loadAppInsights();
      this.filterAppInsights();
    } catch (error) {
      console.log(error);
    }
  }

  private loadCustomTelemetryProperties(props: any) {  
    this.appInsights.addTelemetryInitializer(envelope => {
      var data = envelope.baseData;
      data.properties = data.properties || {};
      for (var key in props) {
        data.properties[key] = props[key];
      }
    });  
  }

  private filterAppInsights() {  
    this.appInsights.addTelemetryInitializer(envelope => {
      var data = envelope.baseData;
      const url = data.url || '';
      const uri = data.uri || '';
      const target = data.target || '';
      const properties = data.properties || {};
      this.urlsToFilter = JSON.parse(this.resourceService.getPortalSetting('Global_AppInsights_FilterByUrls').Value);
      this.exceptionWithPropertiesToFilter = JSON.parse(this.resourceService.getPortalSetting('Global_AppInsights_FilterByProperties').Value);
      const urlToFilter = this.urlsToFilter.find(u => url.includes(u) || uri.includes(u) || target.includes(u));
      const propToFilter = this.exceptionWithPropertiesToFilter.find(e => properties[e.key] == e.value);
      if (urlToFilter || propToFilter) {
        return false; // This prevents logging the telemetry item
      }
      return true;
    });
  }

}
